const questions = [
    {
      "id": 1,
      "wordA": "1.重い",
      "wordB": "2.軽い",
      "wordC": "3.短い",
      "wordD": "4.浅い",
      "answer": [
        1,
        2
      ]
    },
    {
      "id": 2,
      "wordA": "1.太い",
      "wordB": "2.広い",
      "wordC": "3.細い",
      "wordD": "4.小さい",
      "answer": [
        1,
        3
      ]
    },
    {
      "id": 3,
      "wordA": "1.低い",
      "wordB": "2.大きい",
      "wordC": "3.高い",
      "wordD": "4.深い",
      "answer": [
        1,
        3
      ]
    },
    {
      "id": 4,
      "wordA": "1.正しい",
      "wordB": "2.少ない",
      "wordC": "3.明るい",
      "wordD": "4.多い",
      "answer": [
        2,
        4
      ]
    },
    {
      "id": 5,
      "wordA": "1.きれいな",
      "wordB": "2.まっ白な",
      "wordC": "3.美しい",
      "wordD": "4.かわいい",
      "answer": [
        1,
        3
      ]
    },
    {
      "id": 6,
      "wordA": "1.見る",
      "wordB": "2.笑う",
      "wordC": "3.泣く",
      "wordD": "4.聞く",
      "answer": [
        2,
        3
      ]
    },
    {
      "id": 7,
      "wordA": "1.強い",
      "wordB": "2.熱い",
      "wordC": "3.冷たい",
      "wordD": "4.ゆるい",
      "answer": [
        2,
        3
      ]
    },
    {
      "id": 8,
      "wordA": "1.出る",
      "wordB": "2.歩く",
      "wordC": "3.はいる",
      "wordD": "4.休む",
      "answer": [
        1,
        3
      ]
    },
    {
      "id": 9,
      "wordA": "1.午前",
      "wordB": "2.目前",
      "wordC": "3.事前",
      "wordD": "4.直前",
      "answer": [
        2,
        4
      ]
    },
    {
      "id": 10,
      "wordA": "1.貯金",
      "wordB": "2.賃金",
      "wordC": "3.支出",
      "wordD": "4.収入",
      "answer": [
        3,
        4
      ]
    },
    {
      "id": 11,
      "wordA": "1.ぬれた",
      "wordB": "2.よごれた",
      "wordC": "3.かすれた",
      "wordD": "4.かわいた",
      "answer": [
        1,
        4
      ]
    },
    {
      "id": 12,
      "wordA": "1.開会",
      "wordB": "2.入会",
      "wordC": "3.閉会",
      "wordD": "4.休会",
      "answer": [
        1,
        3
      ]
    },
    {
      "id": 13,
      "wordA": "1.逃げる",
      "wordB": "2.追う",
      "wordC": "3.走る",
      "wordD": "4.飛ぶ",
      "answer": [
        1,
        2
      ]
    },
    {
      "id": 14,
      "wordA": "1.きびしい",
      "wordB": "2.愛らしい",
      "wordC": "3.厳格な",
      "wordD": "4.すなおな",
      "answer": [
        1,
        3
      ]
    },
    {
      "id": 15,
      "wordA": "1.参加する",
      "wordB": "2.賛成する",
      "wordC": "3.投票する",
      "wordD": "4.反対する",
      "answer": [
        2,
        4
      ]
    },
    {
      "id": 16,
      "wordA": "1.拡大",
      "wordB": "2.配列",
      "wordC": "3.展開",
      "wordD": "4.縮小",
      "answer": [
        1,
        4
      ]
    },
    {
      "id": 17,
      "wordA": "1.喜劇",
      "wordB": "2.観劇",
      "wordC": "3.悲劇",
      "wordD": "4.娯楽",
      "answer": [
        1,
        3
      ]
    },
    {
      "id": 18,
      "wordA": "1.自主的",
      "wordB": "2.消極的",
      "wordC": "3.積極的",
      "wordD": "4.具体的",
      "answer": [
        2,
        3
      ]
    },
    {
      "id": 19,
      "wordA": "1.正直な",
      "wordB": "2.機敏な",
      "wordC": "3.じょうずな",
      "wordD": "4.へたな",
      "answer": [
        3,
        4
      ]
    },
    {
      "id": 20,
      "wordA": "1.かたづいた",
      "wordB": "2.整とんした",
      "wordC": "3.充実した",
      "wordD": "4.切りつめた",
      "answer": [
        1,
        2
      ]
    },
    {
      "id": 21,
      "wordA": "1.浮く",
      "wordB": "2.泳ぐ",
      "wordC": "3.飲む",
      "wordD": "4.沈む",
      "answer": [
        1,
        4
      ]
    },
    {
      "id": 22,
      "wordA": "1.じかに",
      "wordB": "2.そばに",
      "wordC": "3.直接に",
      "wordD": "4.永久に",
      "answer": [
        1,
        3
      ]
    },
    {
      "id": 23,
      "wordA": "1.むすぶ",
      "wordB": "2.のびる",
      "wordC": "3.ちぢむ",
      "wordD": "4.たたむ",
      "answer": [
        2,
        3
      ]
    },
    {
      "id": 24,
      "wordA": "1.討議",
      "wordB": "2.論文",
      "wordC": "3.世論",
      "wordD": "4.討論",
      "answer": [
        1,
        4
      ]
    },
    {
      "id": 25,
      "wordA": "1.つまらない",
      "wordB": "2.やさしい",
      "wordC": "3.おもしろい",
      "wordD": "4.このましい",
      "answer": [
        1,
        3
      ]
    }
];

export default questions;
